<template>
  <div style="background-color: #fff;">
    <EducationHeader />
    <div class="bannerBox">
      <a-carousel :dot-position="bottom">
        <div>
          <img class="bannerImg" src="@/assets/img/kjrc-zrc.jpg" />
        </div>
      </a-carousel>
    </div>
    <div class="breadBox">
      <a-breadcrumb>
        <span>
          <img src="@/assets/img/position.png" />
          当前位置：
        </span>
        <a-breadcrumb-item>首页</a-breadcrumb-item>
        <a-breadcrumb-item>{{ title }}</a-breadcrumb-item>
      </a-breadcrumb>
    </div>
    <FilterInfo :list="getFilterInfo" @changeValue="getFilterSearch($event)" />
    <div class="listBigBox">
      <div class="industrialBox">
        <!-- <div class="industrialTitleBox">
          <div class="industrialTitle">
            找人才
          </div>
        </div> -->
        <div class="recruitmentContentBox">
          <div class="card" v-for="item in dataSource" :pagination="pagination" :key="item.id" @click="goDetail(item.id)">
            <div class="titleName">{{ item.title }}</div>
            <div class="info">
              <p>咨询电话：{{ item.telephone }}</p>
              <p>报名时间：{{ item.startDate }} ~ {{ item.endDate }}</p>
              <p>招聘地址：{{ item.webAddress }}</p>
            </div>
          </div>
        </div>
        <div class="pagination">
          <a-pagination v-model="current" :total="total" :page-size="pageSize" showQuickJumper
            @change="onChange" />
        </div>
      </div>
    </div>
      <layout-footer/>
  </div>
</template>
<script>
import { getDistMixin, listMixin } from "@/mixins";
import EducationHeader from './educationHeader';
import FilterInfo from '@/components/other/FilterInfo';
import { homeEducationInfo } from "@/api/educationService";
import { file_service } from "@/api/adminService";
import LayoutFooter from "@/layout/layoutPage/footer/LayoutFooterNew2.vue";

export default {
  name: 'innovationBigData',
  mixins: [getDistMixin, listMixin],
  components: {LayoutFooter, EducationHeader, FilterInfo },
  data() {
    return {
      title: '',
      queryParam: {},
      listUrl: homeEducationInfo.findpeopleList,
      current: 1,
      total: 12,
      pageSize: 10,
    }
  },
  created() {
    this.getDist('recruitment_methods')
    this.title = this.$route.query.type
  },
  mounted() {
  },
  computed: {
    getFilterInfo() {
      let list = []
      let obj = {}
      let obj1 = {}
      let obj2 = {}
      let obj3 = {}
      obj1['招聘方式'] = this.releaseTypeArr
      obj['search'] = 'releaseType'
      obj2['arr'] = obj1
      obj3 = Object.assign(obj, obj2)
      list.push(obj3)
      return list
    }
  },
  methods: {
    getImg(imgUrl) {
      return file_service.imagesWeb(imgUrl)
    },
    goDetail(id) {
      this.$router.push({
        path: '/educationService/components/findpeopleDetail',
        query: { type: '找人才', id: id }
      })
    }
  }
}
</script>
<style scoped lang="less">
.bannerBox {
  position: relative;
  width: 100%;
  //margin-bottom: 20px;

  .bannerImg {
    width: 100%;
    height: 100%;
  }
}
.breadBox {
  width: 1200px;
  margin: 0 auto;
  padding: 20px 0;
}

.listBigBox {
  width: 1200px;
  margin: 10px auto;

  .industrialBox {
    width: 1200px;
    margin: 20px auto;

    .industrialTitleBox {
      overflow: hidden;
      width: 100%;
      padding: 15px 0 8px 0;
      margin-bottom: 10px;
      border-bottom: 1px solid #dedede;

      .industrialTitle {
        float: left;
        font-size: 20px;
        color: #333;
      }

      .industrialTitle::before {
        content: '';
        padding-left: 12px;
        border-left: 4px solid #035aea;
      }

      .MoreBox {
        float: right;
        color: #999;
        font-size: 14px;
        cursor: pointer;
      }
    }

    .recruitmentContentBox {
      padding: 14px 0;
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      .card {
        width: 49%;
        padding: 10px;
        border: 1px solid #dedede;
        cursor: pointer;
        margin-bottom: 15px;

        .titleName {
          padding: 10px 0;
          font-size: 18px;
          color: #333;
        }

        .info {
          font-size: 14px;
          color: #666;
        }
      }

      .card:hover {
        border: none;
        -webkit-transition: all 0.3s ease 0s;
        transition: all 0.3s ease 0s;
        //border: 1px solid #ffffff;
        cursor: pointer;
        -webkit-box-shadow: 0 5px 10px 1px #d2e6ff;
        box-shadow: 0 5px 10px 1px #d2e6ff;
      }
    }

    .pagination {
      text-align: center;
      margin-bottom: 20px;
    }
  }
}
</style>
